import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncDepotEdit = lazy(() => import('~/containers/DepotEdit'));

export default [
  <Route path="/depots/:depotId">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncDepotEdit />
    </Suspense>
  </Route>,
];
